import styled, { css } from 'styled-components';

import { InputProps } from '@components/Input/InputProps';
import DefaultInput from '@components/Input/variants/Default';
import { widthMixin } from '@components/Input/variants/mixins';

type OptionalInput = { inputShown?: boolean };

const inputShownContainerMixin = ({ inputShown }: OptionalInput) =>
  inputShown
    ? null
    : css`
        display: flex;
        height: 100%;
      `;
export const Container = styled.div<InputProps & OptionalInput>`
  position: relative;
  ${widthMixin};
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -webkit-appearance: none;
    appearance: none;
  }
  ${inputShownContainerMixin}
  pointer-events: ${(p) => (p.disabled ? 'none' : 'all')};
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  width: ${(p) => p.width};
`;

type Props = {
  mode?: 'active' | 'inactive';
  getInputRef?: unknown;
};
export const InputField = styled(DefaultInput)<Props>`
  opacity: ${({ mode }) => (mode === 'active' ? 1 : 0.4)};
  pointer-events: ${(p) => (p.disabled ? 'none' : 'all')};
`;
